import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from '@/components/ui/accordion';

const faqItems = [
  {
    question: 'Is AI search actually replacing Google?',
    answer:
      'Not replacing \u2014 splitting. A growing percentage of searches now happen through ChatGPT, Claude, Perplexity, and others. These tools pull answers differently than Google. If your site isn\'t set up for them, you don\'t exist in that channel.',
  },
  {
    question: 'Will this mess with my existing SEO?',
    answer:
      'No. ByLLMs adds to your site. It doesn\'t change your existing content, meta tags, or page structure. Your Google rankings stay exactly where they are.',
  },
  {
    question: 'How fast will I see results?',
    answer:
      'Most businesses see AI assistants referencing their site within 1\u20134 weeks of installation. It depends on your industry and how often AI models update their data.',
  },
  {
    question: 'Do I need to do anything after setup?',
    answer:
      'No. We handle installation, optimization, and ongoing monitoring. You don\'t touch code or manage anything.',
  },
  {
    question: 'What if AI already recommends my business?',
    answer:
      'Great \u2014 but is it accurate? Consistent? Better than your competitors? Book a visibility review and we\'ll show you exactly how AI sees you today.',
  },
  {
    question: 'Is this just structured data / schema markup?',
    answer:
      'Structured data is one piece. ByLLMs also creates AI-readable business profiles, monitors how AI models reference you, and adjusts as models change. Schema markup alone won\'t keep you visible as AI evolves.',
  },
];

export default function FaqSection() {
  return (
    <section className="flex flex-col items-center w-full px-4 md:px-0">
      <h2 className="font-headline text-[32px] md:text-[40px] leading-[1.2] text-[#1e1c1c] text-center">
        Questions? Answers.
      </h2>

      <div className="bg-white rounded border border-[rgba(30,28,28,0.1)] max-w-[800px] w-full mx-auto mt-8">
        <Accordion type="single" collapsible>
          {faqItems.map((item, index) => (
            <AccordionItem
              key={index}
              value={`faq-${index}`}
              className="border-b border-[rgba(30,28,28,0.1)]"
            >
              <AccordionTrigger className="font-body font-medium text-[16px] text-[#1e1c1c] hover:no-underline pl-4 pr-6 py-5">
                {item.question}
              </AccordionTrigger>
              <AccordionContent className="font-body font-medium text-sm text-[rgba(30,28,28,0.7)] leading-relaxed pl-4 pr-6 pb-5">
                {item.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
